import React from 'react';
import './LandingPage.css';
import LandingNav from '../components/landing/LandingNav';
import PlatformCompanyInfo from '../components/landing/PlatformCompanyInfo';
import SubscriptionPassPage from './SubscriptionPassPage';

interface LandingPassPurchasePageProps {
  onLoginClick: () => void;
}

const LandingPassPurchasePage: React.FC<LandingPassPurchasePageProps> = ({ onLoginClick }) => {
  return (
    <div className="landing-page landing-pass-page">
      <LandingNav onLoginClick={onLoginClick} />
      <main className="landing-pass-main">
        <header className="landing-qa-header">
          <h1 className="landing-qa-title">이용권 안내</h1>
        </header>
        <SubscriptionPassPage
          variant="landing-purchase"
          requireLoginForCheckout
          onRequestLogin={onLoginClick}
        />
      </main>
      <PlatformCompanyInfo reveal={false} />
    </div>
  );
};

export default LandingPassPurchasePage;
